import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpaceTrimDirective } from '../shared/directives/space-trim.directive';
import { OnlyNumberDirective } from '../shared/directives/only-number.directive';
@NgModule({
  declarations: [
    SpaceTrimDirective,
    OnlyNumberDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SpaceTrimDirective,
    OnlyNumberDirective
  ]
})
export class SharedDirectivesModule { }
